import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { Table } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import ReactPlayer from "react-player";
import { serverInfo } from "../../../../../../App";
// import "./AuditionCardReuse.css";

const LearningSessionResultTable = (props) => {
  const { imageCdnUrl } = useContext(serverInfo);
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 5;
  const { data, tableHead } = props;



  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, data]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };

  return (
    <>
      <>
        <div className="py-3">
          <div className="">
            <Table
              className="tableBorder my-2"
              striped
              bordered
              hover
              variant="dark"
            >
              <thead>
                <tr>
                  {tableHead &&
                    tableHead.map((heading) => (
                      <th className="text-light tableHeader text-center">
                        {heading}
                      </th>
                    ))}
                </tr>
              </thead>

              <tbody>
                {currentItems ? (
                  currentItems.map((data, index) => (
                    <tr key={index}>
                      <td className="text-center">{index + 1}</td>
                      <td className="text-center">{data?.user?.first_name}</td>
                      <td className="text-center">{data?.user?.email}</td>
                      <td className="text-center">{data?.mark}</td>
                    </tr>
                  ))
                ) : (
                  <>
                    <h3 className="text-danger">No Data Found</h3>
                  </>
                )}
              </tbody>
            </Table>
          </div>
        </div>

        <div id="react-paginate">
          <ReactPaginate
            breakLabel="..."
            nextLabel="next >"
            onPageChange={handlePageClick}
            pageRangeDisplayed={3}
            pageCount={pageCount}
            previousLabel="< previous"
            renderOnZeroPageCount={null}
            breakLinkClassName={"page-link"}
            containerClassName={"pagination"}
            pageLinkClassName={"page-link"}
            previousLinkClassName={"page-link"}
            nextLinkClassName={"page-link"}
            activeClassName={"active"}
          />
        </div>
      </>
    </>
  );
};

export default LearningSessionResultTable;
